module.exports = __webpack_public_path__ + "img/loadingIcon1.6ec56638.gif";